import { EnvironmentProviders, Provider, importProvidersFrom } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PlayerStatisticsEffects } from './player-statistics.effects';
import { playerStatisticsReducer } from './player-statistics.reducer';
import { playerStatisticsStateKey } from './player-statistics.state';

export function playerStatisticsProviders(): (Provider | EnvironmentProviders)[] {
    return [
        importProvidersFrom(
            StoreModule.forFeature(playerStatisticsStateKey, playerStatisticsReducer),
            EffectsModule.forFeature([PlayerStatisticsEffects]),
        ),
    ];
}
